import useFeaturePermission from './hooks/useFeaturePermission';
import FeaturePermissionBlock from './components/FeaturePermissionBlock';
import { FEATURE_PERMISSION_TYPE } from './helpers';

export default useFeaturePermission;
export { FEATURE_PERMISSION_TYPE, FeaturePermissionBlock };
